<script>
	import { getContext } from "svelte";
	import { line, area, curveMonotoneX } from "d3-shape";
	import { px } from "../utils.js";

	const { data, xGet, yGet, zGet, xScale, yScale, xRange, yRange, xDomain, yDomain, y } =
		getContext("LayerCake");

	export let strokeWidth = 5;
	$: coordinates = $data.map((group) =>
		group.values.filter((d) => $yGet(d)).map((d) => [$xGet(d), $yGet(d)])
	);

	export let stroke = true;
	export let strokeOpacity = 1;
	export let fill = false;
	export let fillOpacity = 0.5;

	export let smooth = false;
	export let roundToInt = false;

	function roundX(v) {
		return roundToInt ? Math.round(v) : Math.round(v * 1000) / 1000;
	}

	function roundY(v) {
		return roundToInt ? Math.round(v) : Math.round(v * 10) / 10;
	}

	let path;
	$: {
		path = line()
			.x((x) => roundX(x[0]))
			.y((x) => roundY(x[1]));

		if (smooth) path = path.curve(curveMonotoneX);
	}

	let pathArea;

	$: {
		pathArea = area()
			.x((x) => roundX(x[0]))
			.y1((x) => roundY(x[1]))
			.y0(() => $yRange[0]);

		if (smooth) pathArea = pathArea.curve(curveMonotoneX);
	}
</script>

<g class="line-group">
	{#each $data as group, i}
		{#if fill}
			<path
				class="path-fill"
				d={pathArea(coordinates[i])}
				fill={$zGet(group)}
				fill-opacity={fillOpacity}
			/>
		{/if}
		{#if stroke}
			<path
				class="path-line"
				d={path(coordinates[i])}
				stroke={$zGet(group)}
				stroke-opacity={strokeOpacity}
				stroke-width={px(strokeWidth)}
			/>
		{/if}
	{/each}
</g>

<style lang="scss">
	@import "../main.scss";

	.path-line {
		fill: none;
		stroke-linejoin: round;
		stroke-linecap: round;
	}
	.path-fill {
		stroke: none;
	}

	@media (max-width: $text-width) {
		.path-line {
			stroke-width: 2px !important;
		}
	}
</style>
